export default __webpack_public_path__ + "static/media/sprite.cd0a296d.svg";